import { Pipe } from "@angular/core";
import { serializer } from "./safe.util";
export var PrettyJsonPipe = (function () {
    function PrettyJsonPipe() {
    }
    PrettyJsonPipe.prototype.transform = function (obj, spaces) {
        if (spaces === void 0) { spaces = 2; }
        return this._syntaxHighlight(obj, serializer(), spaces);
    };
    PrettyJsonPipe.prototype._syntaxHighlight = function (json, serializer, spacing) {
        if (json === undefined) {
            return '<span class="undefined"></span>';
        }
        // Credits to the accepted answer here http://stackoverflow.com/questions/4810841/how-can-i-pretty-print-json-using-javascript
        if (typeof json !== "string") {
            json = JSON.stringify(json, serializer, spacing);
        }
        json = json.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
            var cls = "number";
            if (/^"/.test(match)) {
                if (/:$/.test(match)) {
                    cls = "key";
                }
                else {
                    cls = "string";
                }
            }
            else if (/true|false/.test(match)) {
                cls = "boolean";
            }
            else if (/null/.test(match)) {
                cls = "null";
            }
            return "<span class=\"" + cls + "\">" + match + "</span>";
        });
    };
    PrettyJsonPipe.decorators = [
        { type: Pipe, args: [{
                    name: "prettyjson",
                    pure: false
                },] },
    ];
    /** @nocollapse */
    PrettyJsonPipe.ctorParameters = function () { return []; };
    return PrettyJsonPipe;
}());
//# sourceMappingURL=prettyjson.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-prettyjson/src/prettyjson.pipe.js
// module id = 140
// module chunks = 10